"use strict";

var _App = require("./App");
// trigger loading of the configuration data
(0, _App.main)();

// initial render
(0, _App.render)();